var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoomplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:##161616;}.cls-2{fill:#010101;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2424.18,
    y1: 1052.95,
    x2: -2415.63,
    y2: 1052.95,
    gradientTransform: "matrix(14, 0, 0, -19, 34055, 20546)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4169b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5dcae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#b2dcbd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2523.49,
    y1: 1061.67,
    x2: -2514.93,
    y2: 1061.67,
    gradientTransform: "matrix(28, 0, 0, -28, 70714, 30271)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4680c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4dc7ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2dcbd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Music-Home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Music_home",
    "data-name": "Music home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4FA7\\u5BFC\\u822A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    className: "cls-1",
    d: "M440.86,535.14a28.82,28.82,0,0,0,5.51-5.18,21.89,21.89,0,0,0,5-14.05,27.94,27.94,0,0,0-11-23.77,47.6,47.6,0,0,0-28.69-7.73H376.31a3.22,3.22,0,0,0-3.28,3.16V592.39a3.08,3.08,0,0,0,1,2.26,3.32,3.32,0,0,0,2.33.94h43a45.19,45.19,0,0,0,28.4-8.1,29.26,29.26,0,0,0,10.9-24.29,29.66,29.66,0,0,0-6.94-19.6,27.6,27.6,0,0,0-10.81-8.46Zm-46.54,11.18h25.25a19.44,19.44,0,0,1,13.12,4.77,15.19,15.19,0,0,1,4.67,11.75A13.78,13.78,0,0,1,432.9,574a20,20,0,0,1-13.46,4H394.19Zm31.73-21a16.67,16.67,0,0,1-11.2,3.57H394.32v-27h17.46a23.25,23.25,0,0,1,14,3.52,14.2,14.2,0,0,1,.26,19.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-2",
    "data-name": "\\u5F62\\u72B6",
    className: "cls-1",
    d: "M501.36,510.07a29.78,29.78,0,0,0-25,12,48.09,48.09,0,0,0-9.12,30v1.55a48.1,48.1,0,0,0,9.15,30,32.19,32.19,0,0,0,50.19,0,48.06,48.06,0,0,0,9.11-30.08V552a48,48,0,0,0-9.15-30A30.09,30.09,0,0,0,501.36,510.07Zm0,17.23a12.52,12.52,0,0,1,11.55,6.58,35.51,35.51,0,0,1,4.26,18.32v1.55a35.71,35.71,0,0,1-4.26,18.43,13.42,13.42,0,0,1-23,0,36,36,0,0,1-4.22-18.43V552.2a36.17,36.17,0,0,1,4.22-18.36A12.33,12.33,0,0,1,501.36,527.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-3",
    "data-name": "\\u5F62\\u72B6",
    className: "cls-1",
    d: "M587,510.07a29.93,29.93,0,0,0-25,12,48.32,48.32,0,0,0-9.08,30v1.56a48,48,0,0,0,9.12,30,32.25,32.25,0,0,0,50.25,0,48.21,48.21,0,0,0,9.07-30.08V552a48,48,0,0,0-9.11-30A30.21,30.21,0,0,0,587,510.07Zm0,17.23a12.56,12.56,0,0,1,11.56,6.58,35.6,35.6,0,0,1,4.27,18.31v1.56a36.13,36.13,0,0,1-4.23,18.43,13.47,13.47,0,0,1-23.05,0,36,36,0,0,1-4.23-18.43v-1.56a35.75,35.75,0,0,1,4.27-18.35A12.29,12.29,0,0,1,587,527.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    className: "cls-1",
    d: "M713.18,510.05a27.36,27.36,0,0,0-15.3,4.33,30.54,30.54,0,0,0-7.44,6.91,22.53,22.53,0,0,0-7-7.15,25.9,25.9,0,0,0-14.59-4.05,30.83,30.83,0,0,0-14.67,3.4,27.34,27.34,0,0,0-5.59,4l-.28-3a3.14,3.14,0,0,0-3.06-2.87H633a3.11,3.11,0,0,0-3.07,3.15v77.68a3.22,3.22,0,0,0,.88,2.26,3,3,0,0,0,2.19.94h13.76a3.05,3.05,0,0,0,2.19-.94,3.22,3.22,0,0,0,.88-2.26V535.85a13.81,13.81,0,0,1,4.8-5.5,15.47,15.47,0,0,1,8.81-2.59,10.63,10.63,0,0,1,8.93,4,23.28,23.28,0,0,1,3.26,14v46.66a3.19,3.19,0,0,0,.89,2.26,3,3,0,0,0,2.18.94h13.85a3,3,0,0,0,2.18-.94,3.18,3.18,0,0,0,.88-2.26V542.6A18.77,18.77,0,0,1,700,531.81a11.44,11.44,0,0,1,9.13-4,10.82,10.82,0,0,1,9,3.64,23.83,23.83,0,0,1,3.15,14.24v46.82a3.15,3.15,0,0,0,3.11,3.2h13.72a3.15,3.15,0,0,0,3.11-3.2V545.88c0-11.65-2.52-20.58-7.43-26.57A25.44,25.44,0,0,0,713.18,510.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    className: "cls-1",
    x: 843.97,
    y: 484.34,
    width: 17.13,
    height: 119.88,
    rx: 6.68
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-4",
    "data-name": "\\u5F62\\u72B6",
    className: "cls-1",
    d: "M945.2,583a68.24,68.24,0,0,1-.39-7.56v-36.8A26.89,26.89,0,0,0,936,517.19a33.4,33.4,0,0,0-22.17-7.12A34,34,0,0,0,891,517.7a21.41,21.41,0,0,0-8.7,17.83,2.32,2.32,0,0,0,0,.83v.4a3.08,3.08,0,0,0,2.91,2.15h12.9a3.06,3.06,0,0,0,3-3.11,7.15,7.15,0,0,1,3-5.72,13.24,13.24,0,0,1,8.73-2.67,12.45,12.45,0,0,1,9.21,3.06,11,11,0,0,1,3.06,8.36v4.45H913.39a43,43,0,0,0-25.2,6.57,23,23,0,0,0-9.94,19.69,25.86,25.86,0,0,0,7,19.05,26.76,26.76,0,0,0,19.88,7,28.05,28.05,0,0,0,14.68-4,38.93,38.93,0,0,0,6-4.54c.23,1.44.5,3,.85,4.7a3,3,0,0,0,3,2.5h14a3,3,0,0,0,2.45-1.27,3.15,3.15,0,0,0,.46-2.74A38.5,38.5,0,0,1,945.2,583Zm-20.08-24.43v8.71a16,16,0,0,1-6.29,6.84,20.68,20.68,0,0,1-11.65,3.43,10,10,0,0,1-7.1-2.15,7.5,7.5,0,0,1-2.1-5.77,9.75,9.75,0,0,1,3.88-7.56,16.33,16.33,0,0,1,11.18-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-2",
    "data-name": "\\u8DEF\\u5F84",
    className: "cls-1",
    d: "M1031.74,511.36a2.75,2.75,0,0,0-2.32-1.33H1015.3a2.83,2.83,0,0,0-2.69,2.11l-14.51,47.3h0l-14.52-47.15a2.92,2.92,0,0,0-2.72-2.1H966.71a2.82,2.82,0,0,0-2.35,1.31,3.3,3.3,0,0,0-.34,2.82l25.4,72.26-2.61,6.75a37.75,37.75,0,0,1-4,7.8,4.94,4.94,0,0,1-4.32,2.57c-.22,0-.94,0-3.16-.2-2.83-.23-5-.39-5.37,2.54a2.44,2.44,0,0,0,0,.54l-1.2,10.18a3.1,3.1,0,0,0,2.11,3.36c1,.27,2.25.5,4,.78a30.23,30.23,0,0,0,4.35.43,19.56,19.56,0,0,0,15.39-6.59,42.79,42.79,0,0,0,8.16-14.2l29.51-86.49a3.2,3.2,0,0,0-.51-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-5",
    "data-name": "\\u5F62\\u72B6",
    className: "cls-1",
    d: "M803.63,510.05a28.69,28.69,0,0,0-13.82,3.2,25.81,25.81,0,0,0-5.95,4.29l-.8-3.71a3,3,0,0,0-2.94-2.42H769.89a2.94,2.94,0,0,0-2.12.91,3.08,3.08,0,0,0-.86,2.18V618.26a3.08,3.08,0,0,0,.86,2.18,2.93,2.93,0,0,0,2.12.9h13.36a3,3,0,0,0,2.12-.9,3.08,3.08,0,0,0,.86-2.18v-29.5a24.31,24.31,0,0,0,4.5,2.61A31.57,31.57,0,0,0,803.86,594a27.83,27.83,0,0,0,23.29-11.08,45.3,45.3,0,0,0,8.21-28.06v-1.45a53.92,53.92,0,0,0-8.1-30.94,27.08,27.08,0,0,0-23.63-12.37ZM816,553.36v1.45a28.85,28.85,0,0,1-4.35,16.58,13.35,13.35,0,0,1-11.91,5.78,15.36,15.36,0,0,1-8.36-2.11,16.24,16.24,0,0,1-5.19-5.46V535a16.58,16.58,0,0,1,5.19-5.54,15,15,0,0,1,8.24-2.18A12.92,12.92,0,0,1,811.57,534,37.74,37.74,0,0,1,816,553.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u8DEF\\u5F84_",
    "data-name": " \\u8DEF\\u5F84 ",
    className: "cls-2",
    cx: 180.37,
    cy: 540,
    r: 132.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84-3",
    "data-name": "\\u8DEF\\u5F84",
    className: "cls-3",
    d: "M235.3,497.06q5.65-35.68-32.51-38.38h-35.3a13.14,13.14,0,0,0-13.72,10.57L151,479.06l30.76-1c6.9-1.48,15.55,4,20.38,13.75,5.42,10.8,3.39,20.69-3.79,24.35s-16.75-.33-22.18-11.09c-4-8-4.27-15.35-1-20.7l-25.49.8-18.07,62.13,38.33-1.53c9.09-2,20.58,5.26,27,17.88,7.26,14.19,5.55,27.13-4,32.15s-22.94,0-30.2-14.23c-5.5-10.73-5.82-20.69-1.63-27.76l-31.91,1.24s-11.77,40.95-12,42.48a44.54,44.54,0,0,0-1.12,6.71,17,17,0,0,0,16.95,17.07h26.17c33.9-1.8,56.08-17.8,66.73-47.61q7-33.87-23.93-40.19l.24-.88Q226.4,525.51,235.3,497.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6-6",
    "data-name": "\\u5F62\\u72B6",
    className: "cls-4",
    d: "M176.09,424.41A119.88,119.88,0,1,0,296,544.28,119.88,119.88,0,0,0,176.09,424.41Zm0,231.58A111.75,111.75,0,1,1,287.8,544.28,111.75,111.75,0,0,1,176.09,656Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomplay);
export default __webpack_public_path__ + "static/media/boomplay.29bb3cc591681de093931663273ed02c.svg";
export { ForwardRef as ReactComponent };